export function commonErrorHandling(res: any, dispatch: any, requestFailure: (msg: any) => any) {
	const status: number = res.status;
	const statusText: string = res.statusText;
	if (!res) {
		console.error('Response missing for commonError nandling');
		return;
	}
	console.error(res);
	if (!res.json) {
		dispatch(requestFailure(res));
		return Promise.resolve(res);
	}
	return res
		.json()
		.then((res) => {
			res.status = status;
			res.statusText = statusText;
			dispatch(requestFailure(res));
		})
		.catch(() => {
			dispatch(requestFailure(res));
			return res;
		});
}

export function requestHelper<TResponse>(request: Promise<Response>, returnHeadersKey?: string): Promise<TResponse> {
	return request
		.then((res) => {
			if (res.ok) {
				if (returnHeadersKey) {
					return res.headers.get(returnHeadersKey);
				}
				return res.json().catch(() => {
					return true;
				});
			} else {
				return res
					.json()
					.catch(() => {
						throw res.statusText;
					})
					.then((err) => {
						throw err;
					});
			}
		})
		.catch((reason) => {
			console.error(reason);
			throw reason;
		});
}

type SettledPromise = { status: 'fulfilled' | 'rejected'; value?: any; reason?: any };

export function handleSettledPromises<T = any>(
	resolved: SettledPromise[],
	onError: (msg: any) => void,
	onAnySuccess?: (succeeded: number) => T,
): T {
	const anySuccessful = !resolved.length || resolved.some((r) => r.status === 'fulfilled');
	resolved.forEach((r) => {
		if (r.status === 'rejected') {
			onError(r.reason);
		}
	});
	if (anySuccessful && onAnySuccess) {
		return onAnySuccess(resolved.filter((r) => r.status === 'fulfilled').length);
	}
}
